import { CellClassParams } from "ag-grid-community";
import { AgColDefsI, AgGridI } from "../../../shared/components/ag-grid/ag-grid.model";
import { CellCheckboxComponent } from "../../../shared/components/ag-grid/cell-checkbox/cell-checkbox.component";
import { CheckboxRendererComponent } from "../../../shared/components/ag-grid/checkbox-renderer/checkbox-renderer.component";
import { InputRendererComponent } from "../../../shared/components/ag-grid/input-renderer/input-renderer.component";
import { SelectRendererComponent } from "../../../shared/components/ag-grid/select-renderer/select-renderer.component";
import { HistoryHeader } from "../../../shared/model/ag-grid-common-constant";
import { DocumentCellRendererComponent } from "../../crm/companies/pages/company-info-tabs/document-cell-renderer/document-cell-renderer.component";
import { GridName } from "../../crm/crm.model";

const QtyColumn: AgColDefsI = {
  headerName: 'Qty',
  field: "qty",
  sortable: false,
  resizable: false,
  suppressMovable: false,
  cellClass: "custom-part-number-cell",
  headerClass: "ps-03",
  editable :false,
  minWidth: 150,
  flex:1,
  cellRenderer: InputRendererComponent,
  cellRendererParams: {isOnlyNumbersEnabled: true},
};
const DateCodeYearColumn: AgColDefsI = {
    headerName: 'Date Code Year',
    field: "dateCodeYearId",
    sortable: false,
    resizable: false,
    suppressMovable: false,
    cellClass: "custom-part-number-cell",
    editable :false,
    minWidth: 140,
    flex:1,
    cellRenderer: SelectRendererComponent
  };
  
  const DateCodeWeekColumn: AgColDefsI = {
    headerName: 'Date Code Week',
    field: "dateCodeWeekId",
    sortable: false,
    resizable: false,
    suppressMovable: false,
    cellClass: "custom-part-number-cell",
    editable :false,
    minWidth: 140,
    flex:1,
    cellRenderer: SelectRendererComponent
  };
  const LotCodeColumn: AgColDefsI = {
    headerName: 'Lot Code',
    field: "lotCode",
    sortable: false,
    resizable: false,
    suppressMovable: false,
    cellClass: "custom-part-number-cell",
    editable :false,
    minWidth: 140,
    flex:1,
    cellRenderer: InputRendererComponent,
};
  const RoHSColumn: AgColDefsI = {
    headerName: 'RoHS',
    field: "rohsId",
    sortable: false,
    resizable: false,
    suppressMovable: false,
    cellClass: "custom-part-number-cell",
    editable :false,
    minWidth: 140,
    flex:1,
    cellRenderer: SelectRendererComponent
  };
  const ConditionColumn: AgColDefsI = {
    headerName: 'Condition',
    field: "conditionId",
    sortable: false,
    resizable: false,
    suppressMovable: false,
    cellClass: "custom-part-number-cell",
    editable :false,
    minWidth: 140,
    flex:1,
    cellRenderer: SelectRendererComponent
  };
  const CooColumn: AgColDefsI = {
    headerName: 'COO',
    field: "cooId",
    sortable: false,
    resizable: false,
    suppressMovable: false,
    cellClass: "custom-part-number-cell",
    editable :false,
    minWidth: 100,
    flex:1,
    cellRenderer: SelectRendererComponent
  };
  const ActionColumn: AgColDefsI = {
    headerName: '',
    field: "",
    sortable: false,
    resizable: false,
    suppressMovable: false,
    cellClass: "custom-part-number-cell",
    editable :false,
    minWidth: 200,
    flex:1,
    cellRenderer: DocumentCellRendererComponent,
    cellRendererParams: {splitLine: true},
  };

  const ViewQtyColumn: AgColDefsI = {
    headerName: 'Sub Qty',
    field: "qty",
    sortable: false,
    resizable: false,
    suppressMovable: false,
    cellClass: "custom-part-number-cell",
    editable :false,
    minWidth: 150,
    flex:1,
    cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
  };
  const ViewDateCodeYearColumn: AgColDefsI = {
      headerName: 'Date Code',
      field: "dateCodeYearName",
      sortable: false,
      resizable: false,
      suppressMovable: false,
      cellClass: "custom-part-number-cell",
      editable :false,
      minWidth: 140,
      flex:1,
      cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
    };
    const ViewLotCodeColumn: AgColDefsI = {
      headerName: 'Lot Code',
      field: "lotCode",
      sortable: false,
      resizable: false,
      suppressMovable: false,
      cellClass: "custom-part-number-cell",
      editable :false,
      minWidth: 140,
      flex:1,
      cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
  };
    const ViewRoHSColumn: AgColDefsI = {
      headerName: 'RoHS',
      field: "rohsName",
      sortable: false,
      resizable: false,
      suppressMovable: false,
      cellClass: "custom-part-number-cell",
      editable :false,
      minWidth: 140,
      flex:1,
      cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
    };
    const ViewConditionColumn: AgColDefsI = {
      headerName: 'Condition',
      field: "conditionName",
      sortable: false,
      resizable: false,
      suppressMovable: false,
      cellClass: "custom-part-number-cell",
      editable :false,
      minWidth: 140,
      flex:1,
      cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
    };
    const ViewCooColumn: AgColDefsI = {
      headerName: 'COO',
      field: "cooName",
      sortable: false,
      resizable: false,
      suppressMovable: false,
      cellClass: "custom-part-number-cell",
      editable :false,
      minWidth: 100,
      flex:1,
      cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
    };
    const ViewActionColumn: AgColDefsI = {
      headerName: '',
      field: "",
      sortable: false,
      resizable: false,
      suppressMovable: false,
      cellClass: "custom-part-number-cell d-flex justify-content-end",
      editable :false,
      minWidth: 200,
      cellRenderer: DocumentCellRendererComponent,
      cellRendererParams: {splitLine: true,hideIcon: true},
      
    };
  const MessageColumn: AgColDefsI = {
    headerName: HistoryHeader.MESSAGE,
    field: "message",
    editable:false,
    suppressMovable: false,
    uniqueName:'historyMessage',
    minWidth: 115,
    sortable: true,
    resizable: false,
    cellClass: "custom-part-number-cell" ,
    cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
  };
  
  const ActionHistoryColumn: AgColDefsI = {
    headerName: HistoryHeader.ACTION,
    field: "action",
    sortable: true,
    editable:false,
    minWidth: 120,
    flex:1,
    cellClass: "custom-part-number-cell" ,
    resizable: false,
    cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
  };
  const ByColumn: AgColDefsI = {
    headerName: HistoryHeader.BY,
    field: "createdBy",
    sortable: true,
    editable:false,
    minWidth: 95,
    flex:1,
   cellClass: "custom-part-number-cell" ,
   resizable: false,
   cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
  };
  const DateColumn: AgColDefsI = {
    headerName: HistoryHeader.DATE,
    field: "createdAt",
    sortable: true,
    editable:false,
    minWidth: 109,
    flex:1,
    cellClass: "custom-part-number-cell" ,
    resizable: false,
    cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
  };
  const SoStatusColumn: AgColDefsI = {
    headerName:'SO Status',
    field: "status",
    sortable: true,
    editable:false,
    minWidth: 109,
    flex:1,
    cellClass: "custom-part-number-cell" ,
    resizable: false,
    cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
  };
  const SoNoColumn: AgColDefsI = {
    headerName:'SO No',
    field: "soNo",
    sortable: true,
    editable:false,
    minWidth: 109,
    flex:1,
    cellClass: "text-semi-primary text-underline" ,
    resizable: false,
    cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
  };
  const AllocationsQtyColumn: AgColDefsI = {
    headerName:'Qty',
    field: "status",
    sortable: true,
    editable:false,
    minWidth: 109,
    flex:1,
    cellClass: "custom-part-number-cell" ,
    resizable: false,
    cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
  };

  const customerColumn: AgColDefsI = {
    headerName:'Customer',
    field: "status",
    sortable: true,
    editable:false,
    minWidth: 109,
    flex:1,
    cellClass: "text-semi-primary text-underline" ,
    resizable: false,
    cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
  };
  const partNoColumn: AgColDefsI = {
    headerName:'Part No',
    field: "status",
    sortable: true,
    editable:false,
    minWidth: 109,
    flex:1,
    cellClass: "custom-part-number-cell" ,
    resizable: false,
    cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
  };
  const MFRColumn: AgColDefsI = {
    headerName:'Mfr',
    field: "status",
    sortable: true,
    editable:false,
    minWidth: 109,
    flex:1,
    cellClass: "custom-part-number-cell" ,
    resizable: false,
    cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
  };

  const WarehouseColumn: AgColDefsI = {
    headerName:'Warehouse',
    field: "status",
    sortable: true,
    editable:false,
    minWidth: 109,
    flex:1,
    cellClass: "custom-part-number-cell" ,
    resizable: false,
    cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
  };
  const LocationColumn: AgColDefsI = {
    headerName:'Location',
    field: "status",
    sortable: true,
    editable:false,
    minWidth: 109,
    flex:1,
    cellClass: "custom-part-number-cell" ,
    resizable: false,
    cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
  };

  const SOUnitPriceColumn: AgColDefsI = {
    headerName:'SO Unit Price',
    field: "status",
    sortable: true,
    editable:false,
    minWidth: 109,
    flex:1,
    cellClass: "custom-part-number-cell" ,
    resizable: false,
    cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
  };
  const VendorColumn: AgColDefsI = {
    headerName:'Vendor',
    field: "vendor",
    sortable: true,
    headerCheckboxSelection: true,
    checkboxSelection: true,
    headerClass: "ps-3",
    suppressMovable: false,
    cellClass: "custom-part-number-cell text-grey-color",
    lockPinned: true,
    lockPosition: "left",
    editable :false,
    minWidth: 170,
    flex:1,
    cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
  };
  
  const VendorContactColumn: AgColDefsI = {
    headerName:'Vendor Contact',
    field: "vendorContact",
    sortable: true,
    editable:false,
    minWidth: 109,
    flex:1,
    cellClass: "custom-part-number-cell" ,
    cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
  };
  const VendorTypeColumn: AgColDefsI = {
    headerName:'Vendor Type',
    field: "recordType",
    sortable: true,
    editable:false,
    minWidth: 109,
    flex:1,
    cellClass: "custom-part-number-cell" ,
    cellRenderer: params => params.value ?params.value : "&#8212",
  };
  const ExpiredpartColumn: AgColDefsI = {
    headerName:'No. of Expired Parts',
    field: "expirationCount",
    sortable: true,
    editable:false,
    minWidth: 109,
    flex:1,
    cellClass: "custom-part-number-cell" ,
    cellRenderer: params => params.value ?params.value : "&#8212",
  };
  const AvlColumn: AgColDefsI = {
    headerName:'AVL',
    field: "isAvl",
    sortable: true,
    editable:false,
    minWidth: 109,
    flex:1,
    cellClass: "custom-part-number-cell" ,
    // cellRenderer: params => params.value ?params.value : "&#8212",
    cellRenderer: params => {
    if (params.value === true) return 'Yes';
    if (params.value === false) return 'No';
    return '&#8212';
  }
  };
  const VendorNameColumn: AgColDefsI = {
    headerName:'Vendor Name',
    field: "vendor",
    sortable: true,
    headerCheckboxSelection: true,
    checkboxSelection: true,
    suppressMovable: false,
    lockPinned: true,
    lockPosition: "left",
    editable :false,
    minWidth: 170,
    flex:1,
    headerClass: (params: any) => {
    const baseClass = 'ps-3';
    const isDisabled = params.context?.storageName === GridName.SEND_REQUEST;
    return isDisabled ? `${baseClass} disabled-checkbox` : baseClass;
  },
  cellClass: (params: any) => {
    const baseClass = 'custom-part-number-cell';
    const isDisabled = params.context?.storageName === GridName.SEND_REQUEST;
    return isDisabled ? `${baseClass} disabled-checkbox` : baseClass;
  }
  };
  const SendToPartContactColumn: AgColDefsI = {
    field: "partContact",
    headerComponent: CheckboxRendererComponent,
    suppressMenu: true,
    width: 50,
    minWidth: 195,
    editable: false,
    sortable: true,
    flex:1,
     cellRenderer: CellCheckboxComponent,
    resizable:true,
    cellRendererParams: { context: this},
    headerComponentParams: { context: this ,label: "Send to Part Contact"},
    cellStyle: {
      'padding-left':'19px',
    },
  };
  
  const ContactEmailColumn: AgColDefsI = {
    headerName:'Contact Email',
    field: "vendorContactEmail",
    sortable: true,
    editable:false,
    minWidth: 109,
    flex:1,
    cellClass: "custom-part-number-cell" ,
    cellRenderer: params => params.value ?params.value : "&#8212",
  };
  const ContactColumn: AgColDefsI = {
    headerName:'Contact',
    field: "vendorContactId",
    sortable: false,
    suppressMovable: false,
    cellClass: "custom-part-number-cell",
    editable :false,
    minWidth: 140,
    flex:1,
    // cellRenderer: SelectRendererComponent,
    // cellRendererSelector: (params) => {
    //   if (!params.data?.partContact) {
    //     return params.value;
    //   }
    //   return { component: SelectRendererComponent };
    // },
    cellRendererParams:{contactListShow:true},
    valueGetter: (params) => {
    if (!params.data?.partContact) {
      return params?.data?.vendorContact;
    }
    return params.data.vendorContactId;
  },
  cellRendererSelector: (params) => {
    if (!params.data?.partContact) {
      return undefined;
    }
    return {
      component: SelectRendererComponent,
      params: {
        contactList: params.data.partContact
      }
    };
  }
  };
  const ContactNameColumn: AgColDefsI = {
    headerName:'Contact',
    field: "vendorContact",
    sortable: false,
    suppressMovable: false,
    cellClass: "custom-part-number-cell",
    editable :false,
    minWidth: 140,
    flex:1,
    cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
  };


  export const ColDefsLineInfo: AgColDefsI[] = [
    QtyColumn,
    DateCodeYearColumn,
    DateCodeWeekColumn,
    LotCodeColumn,
    RoHSColumn,
    ConditionColumn,
    CooColumn,
    ActionColumn
  ];
  
  export const AgGridDataModelLineInfo: AgGridI = {
    colDefs: ColDefsLineInfo,
    storageName : GridName.LINEINFORMATION,
    rowSelection: "multiple",
  };
  export const ColDefsViewLineInfo: AgColDefsI[] = [
    ViewQtyColumn,
    ViewDateCodeYearColumn,
    ViewLotCodeColumn,
    ViewRoHSColumn,
    ViewConditionColumn,
    ViewCooColumn,
    ViewActionColumn
  ];
  
  export const AgGridDataModelViewLineInfo: AgGridI = {
    colDefs: ColDefsViewLineInfo,
    storageName : GridName.VIEWLINEINFORMATION,
    rowSelection: "multiple",
  };
  export const ColDefsViewLineHistory: AgColDefsI[] = [
    ActionHistoryColumn,
    MessageColumn,
    ByColumn,
    DateColumn,
    ];
  
  export const AgGridDataModelLineHistory: AgGridI = {
    colDefs: ColDefsViewLineHistory,
    storageName : GridName.LINEHISORTY,
    rowSelection: "multiple",
  };

  export const ColDefsViewAllocations: AgColDefsI[] = [
    SoStatusColumn,
    SoNoColumn,
    AllocationsQtyColumn,
    customerColumn,
    partNoColumn,
    MFRColumn,
    WarehouseColumn,
    LocationColumn,
    SOUnitPriceColumn
    ];
  
  export const AgGridDataModelAllocations: AgGridI = {
    colDefs: ColDefsViewAllocations,
    storageName : GridName.LINE_ALLOCATION,
    rowSelection: "multiple",
  };

  export const ColDefsRequestVendor: AgColDefsI[] = [
    VendorColumn,
    VendorContactColumn,
    VendorTypeColumn,
    ExpiredpartColumn,
    AvlColumn,
    ];
  
  export const AgGridDataModelRequestVendor: AgGridI = {
    colDefs: ColDefsRequestVendor,
    storageName : GridName.REQUEST_VENDOR,
    rowSelection: "multiple",
  };

  export const ColDefsConfirmSelection: AgColDefsI[] = [
    VendorNameColumn,
    VendorTypeColumn,
    SendToPartContactColumn,
    ContactColumn,
    ContactEmailColumn
    ];
    export const ColDefsSendRequest: AgColDefsI[] = [
      VendorNameColumn,
      VendorTypeColumn,
      SendToPartContactColumn,
      ContactNameColumn,
      ContactEmailColumn
      ];
    
  
  
  export const AgGridDataModelConfirmSelection: AgGridI = {
    colDefs: ColDefsConfirmSelection,
    storageName : GridName.CONFIRM_SELECTION,
    rowSelection: "multiple",
  };
  export const AgGridDataModelSendRequest: AgGridI = {
    colDefs: ColDefsSendRequest,
    storageName : GridName.SEND_REQUEST,
    rowSelection: "multiple",
  };

